export default __webpack_public_path__ + "static/media/reconectme_icone_positivo.3320381c.png";